module.exports = __webpack_public_path__ + "static/img/circle-i-outline.f6dde7a8.svg";